import { createSlice } from '@reduxjs/toolkit';

const signalSlice = createSlice({
  name: 'signal',
  initialState: {},
  reducers: {
    setSignal: (state, action) => action.payload,
  },
});

const { setSignal } = signalSlice.actions;

export default signalSlice.reducer;
export {
  setSignal,
};
